<div class="inner-page-section">
    <div class="sub-section-header">
        <h1 class="title">Suppress Integrations</h1>
    </div>

    <mat-card appearance="outlined">
        <mat-card-header>Integrations selected below will be excluded from workbench case requirements.</mat-card-header>

        <mat-card-content>
            <p class="small-text">
                When a case is evaluated in the New Business Workbench, the system generates requirements
                based on the integrations configured for this account. Any integration selected here will
                be suppressed by default — it will not automatically appear as a case requirement in the
                workbench based on case data or interview responses.
            </p>
            <p class="small-text">
                Common use cases include integrations that run automatically via workflow triggers and
                should not be surfaced to the user as a manual requirement, or integrations that are not
                applicable in a workbench context (e.g., back-office or reporting-only integrations).
            </p>
            <p class="small-text">
                <strong>Note:</strong> A suppressed integration can still appear as a requirement if a
                requirement rule is explicitly configured to target a specific post-action for that
                integration. This setting suppresses automatic requirement generation, not requirements
                that are directly tied to a post-action by configuration.
            </p>
        </mat-card-content>

        <mat-card-content *ngIf="!dataLoaded">
            <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
        </mat-card-content>

        <mat-card-content *ngIf="dataLoaded">
            <auto-suggest
                [list]="integrations"
                field="name"
                dataKey="integrationId"
                [multiple]="true"
                placeholder="Excluded Integrations"
                [ngModel]="selectedIntegrationIds"
                (newValueChanges)="onSelectionChange($event)">
            </auto-suggest>
        </mat-card-content>

        <mat-card-content *ngIf="errorMessage" style="color: var(--mat-sys-error);">
            {{ errorMessage }}
        </mat-card-content>
    </mat-card>
</div>
